<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
/* 全局变量 */
:root {
  /* 主题色 */
  --primary-color: #667eea;
  --primary-light: #764ba2;
  --secondary-color: #f5f7fa;
  --text-color: #333;
  --text-light: #666;
  --text-lighter: #999;
  --border-color: #e1e5eb;
  --success-color: #67c23a;
  --warning-color: #e6a23c;
  --danger-color: #f56c6c;
  --info-color: #909399;
  
  /* 阴影 */
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.08);
  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.12);
  --shadow-lg: 0 8px 32px rgba(0, 0, 0, 0.15);
  
  /* 圆角 */
  --border-radius-sm: 4px;
  --border-radius-md: 8px;
  --border-radius-lg: 12px;
  
  /* 间距 */
  --spacing-xs: 4px;
  --spacing-sm: 8px;
  --spacing-md: 16px;
  --spacing-lg: 24px;
  --spacing-xl: 32px;
  
  /* 过渡 */
  --transition-fast: 0.2s ease;
  --transition-normal: 0.3s ease;
  --transition-slow: 0.5s ease;
}

/* 全局重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-color);
  background-color: #f0f2f5;
  line-height: 1.5;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 全局滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
  transition: all var(--transition-normal);
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 全局按钮样式 */
.el-button {
  border-radius: var(--border-radius-md);
  transition: all var(--transition-normal);
}

.el-button--primary {
  background: linear-gradient(135deg, var(--primary-color), var(--primary-light));
  border: none;
}

.el-button--primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

/* 全局卡片样式 */
.el-card {
  border-radius: var(--border-radius-lg);
  overflow: hidden;
  transition: all var(--transition-normal);
}

.el-card:hover {
  box-shadow: var(--shadow-md);
}

/* 全局表单样式 */
.el-form-item {
  margin-bottom: var(--spacing-md);
}

.el-input__inner {
  border-radius: var(--border-radius-md);
  transition: all var(--transition-normal);
}

.el-input__inner:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* 全局加载动画 */
.el-loading-spinner .path {
  stroke: var(--primary-color);
}

/* 全局消息提示 */
.el-message {
  min-width: 300px;
  border-radius: var(--border-radius-md);
  box-shadow: var(--shadow-md);
}

/* 全局确认对话框 */
.el-dialog {
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-lg);
}

/* 全局表格样式 */
.el-table {
  border-radius: var(--border-radius-md);
  overflow: hidden;
}

.el-table th {
  background-color: #f8f9fa;
  font-weight: 600;
}

/* 全局工具提示 */
.el-tooltip__popper {
  border-radius: var(--border-radius-sm);
  box-shadow: var(--shadow-sm);
}

/* 全局标签页 */
.el-tabs__active-bar {
  background-color: var(--primary-color);
}

.el-tabs__item.is-active {
  color: var(--primary-color);
}

/* 全局选择器 */
.el-select .el-input.is-focus .el-input__inner {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* 全局日期选择器 */
.el-date-picker__header-label.active {
  color: var(--primary-color);
}

.el-date-picker__time-header {
  color: var(--primary-color);
}

/* 全局上传组件 */
.el-upload--picture-card {
  border-radius: var(--border-radius-md);
  transition: all var(--transition-normal);
}

.el-upload--picture-card:hover {
  border-color: var(--primary-color);
  transform: translateY(-2px);
}

/* 路由过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity var(--transition-normal);
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 页面加载动画 */
.page-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  :root {
    --spacing-lg: 16px;
    --spacing-xl: 24px;
  }
  
  body {
    font-size: 14px;
  }
}
</style>
